import { api } from "../base";
import { resolveCurrentEnv } from "../config";

export type {
  IQuote,
  IQuoteRequest,
  IQuoteRequestReject,
} from "@pulse-ui/codegen-v2/generated_ts/quoting";

// Maps each quoting account (e.g. "digital.dev.partition0.esp") to its routing kind.
export type QuotingAccountRouting = Record<string, string>;

export type QuotingAccountKind =
  | "executable_streaming_prices"
  | "request_for_quote"
  | "request_for_stream"
  | "order_entry";

export function quotingAccountsForKind(
  routing: QuotingAccountRouting | undefined,
  kind: QuotingAccountKind,
): string[] {
  return Object.entries(routing ?? {})
    .filter(([, v]) => v === kind)
    .map(([account]) => account)
    .sort((a, b) => a.localeCompare(b));
}

// Dev-like origins (localhost, cs-dev) prefer the first "dev" account; else the first.
export function defaultQuotingAccount(
  routing: QuotingAccountRouting | undefined,
  kind: QuotingAccountKind,
): string | null {
  const accounts = quotingAccountsForKind(routing, kind);
  if (accounts.length === 0) return null;
  if (resolveCurrentEnv().includes("dev")) {
    return accounts.find((a) => a.includes("dev")) ?? accounts[0];
  }
  return accounts[0];
}

const quotingEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getQuotingAccountRouting: build.query<QuotingAccountRouting, void>({
      query: () => ({
        url: "/api/trade/v1/quoting-account-routing",
      }),
    }),
  }),
});

export const {
  useGetQuotingAccountRoutingQuery,
  endpoints: quotingApiEndpoints,
} = quotingEndpoints;
